module.exports = __webpack_public_path__ + "img/hero-2-bg.672deb4f.png";